<template lang="pug">
  .arrows(:class="{ 'arrows--inactive': swiperInactive }")
    button.arrow.arrow--prev(@click="changePrev")

    .arrows__numbers(v-html="calculatedNumbers")

    button.arrow.arrow--next(@click="changeNext")

    .arrows__progress
      .challenge__progress__current(:style="{ width: progressWidth, left: progressPosition }")
</template>

<script>

export default {
  name: "SwiperArrows",
  props: {
    activeSlide: {
      type: Number,
      default: null,
    },
    totalSlides: {
      type: Number,
      default: null,
    },
  },
  computed: {
    swiperInactive() {
      return this.totalSlides === 1
    },
    calculatedNumbers() {
      return this.activeSlide + " / " + this.totalSlides;
    },
    progressWidth() {
      if (this.swiperInactive) {
        return 0;
      }

      return 1 / this.totalSlides * 100 + "%";
    },
    progressPosition() {
      return (this.activeSlide - 1) * 1 / this.totalSlides * 100 + "%";
    },
  },
  methods: {
    changePrev() {
      if (!this.swiperInactive) {
        this.$emit("changePrev");
      }
    },
    changeNext() {
      if (!this.swiperInactive) {
        this.$emit("changeNext");
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/style/blocks/swiper-arrows.scss";
</style>